export default __webpack_public_path__ + "static/media/5_1.7b5870d0.png";